jQuery(document).ready(function($) {
	// Do this after the page has loaded
	$(window).on('load', function(){
		/*
		Twitter Feed Accessibility 
		IFrame html is used to format content
		*/
		var twitter_iframe = $('iframe[id^="twitter-widget-"], iframe[src^="https://platform.twitter.com"]'); 

		if( twitter_iframe.length ){
			twitter_iframe.each(function(index, element) {
				stripeIframeAttributes(element);
			});

			setTimeout(function(){
				var rufous_iframe = $('iframe[id="rufous-sandbox"]'); 
				stripeIframeAttributes(rufous_iframe);
			}, 1000);
		}
	});

	function stripeIframeAttributes(frame){
		$(frame).removeAttr('frameborder');
		$(frame).removeAttr('scrolling');
		$(frame).removeAttr('allowtransparency');
		$(frame).removeAttr('allowfullscreen');
	}
});